import { Component } from "react";
import { connect } from "react-redux";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import {
  hideNewInventoryModal,
  addNewItem,
} from "../redux-state/features/inventory/inventorySlice";
import AddNewInventoryItem from "./newInventroyForm";
import ItemsTable from "./newItemTable";
import axios from "axios";
import urls from "../urls";
import { showSuccess, showError } from "../utils";
class NewInventoryModal extends Component {
  handleClose = () => {
    this.props.hideNewInventoryModal();
  };
  handleAddnewItem = (item) => {
    this.props.addNewItem(item);
  };
  handelSaveChanges = () => {
    const { items } = this.props;
    if (!items.length) {
      showError("يجب اضافة عنصر على الأقل ");
      return;
    }
    axios
      .post(urls.addNewInventory, { items, faculty_id: this.props.faculty_id })
      .then((res) => {
        showSuccess("تم إضافة الجرد  بنجاح ");
        this.props.hideNewInventoryModal();
      })
      .catch((err) => {
        showError("حدث خطأ أثناء الحفظ ");
      });
  };
  render() {
    const { show, items } = this.props;
    return (
      <div>
        <Modal
          show={show}
          onHide={this.handleClose}
          backdrop="static"
          keyboard={false}
          size="lg"
        >
          <Modal.Header closeButton>
            <Modal.Title style={{ fontSize: "13px" }}>
              إضافة جرد جديد
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <AddNewInventoryItem onNewItem={this.handleAddnewItem} />
            <hr />
            {items.length > 0 && <ItemsTable />}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="warning" onClick={this.handelSaveChanges}>
              حفظ التغييرات
            </Button>
            <Button variant="secondary" onClick={this.handleClose}>
              إلغاء العملية
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

const mapDispatchToProps = { hideNewInventoryModal, addNewItem };
const mapStateToProps = (state) => ({
  show: state.inventoryState.showNewInventoryModal,
  items: state.inventoryState.newItems,
  faculty_id: state.userState.faculty_id,
});
export default connect(mapStateToProps, mapDispatchToProps)(NewInventoryModal);
